import {Button, Card, Result} from "antd";
import {useHistory} from "react-router-dom";

export default function RegisterSuccess() {
    const history = useHistory();

    const redirectLogin = () => {
        history.push('/app/login')
    }

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', backgroundColor: '#edf2f8'}}>
                <Card title={'Confirm Email'} style={{minWidth: 400}}>
                    <Result
                        status="info"
                        subTitle="Your account has been created successfully."
                        title="Check your email to confirm your account!"
                        extra={[
                            <Button type="primary" key="console" onClick={redirectLogin}>
                                Login
                            </Button>
                        ]}
                    />
                </Card>
            </div>
        </>
    )
}